import { HttpInterceptorFn, HttpHandlerFn, HttpRequest } from '@angular/common/http';

const MUTABLE_METHODS = ['POST', 'PUT', 'PATCH'];

const trimStrings = (value: unknown): unknown => {
  if (typeof value === 'string') {
    return value.trim();
  }

  if (Array.isArray(value)) {
    return value.map(trimStrings);
  }

  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value as Record<string, unknown>).map(([k, v]) => [k, trimStrings(v)]));
  }

  return value;
};

export const trimInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (!MUTABLE_METHODS.includes(req.method) || req.body instanceof FormData) {
    return next(req);
  }

  return next(req.clone({ body: trimStrings(req.body) }));
};
